import React from 'react';
import { connect } from 'react-redux';
import Pusher from 'pusher-js';
import { browserHistory } from 'react-router';
import { push } from 'react-router-redux';
import { isDirty } from 'redux-form';

import {
  ContentWrapper,
  PageWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
} from 'components/wrappers/pages';
import { PUSHER_APP_KEY } from 'api/constants';
import { askConfirmAction } from 'actions/confirm-action';
import NoDataAndLoading from 'components/NoDataAndLoading';
import {
  pageRequest,
  confirmApplySetItem,
  onClickApplyAllitem,
  setModifierApplyAllItems,
  closeSetAllItemConfirmation,
  deleteModifier,
  setDeletedModifier,
  hideDeleteModifierModal,
  handleSuccessAsyncJob,
  handleFailedAsyncJob,
} from 'actions/businessLibrary/modifier';
import LibraryDeleteModal from 'components/LibraryDeleteModal';
import ConfirmActionModal from 'components/ConfirmActionModal';

import ActionBar from './ActionBar';
import List from './List';
import Detail from './Detail';
import ApplySetItemModal from './ApplySetItemModal';
import ConfirmSetAllItemModal from './ConfirmSetAllItemModal';

class Modifier extends React.Component {
  componentDidMount() {
    const { pageRequest } = this.props;
    const { businessId } = this.props;
    const pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: 'ap1',
      encrypted: true,
    });
    browserHistory.listenBefore(this.routerWillLeave);
    this.channel = pusher.subscribe(`moka-${businessId}`);
    pageRequest();
  }

  componentWillUnmount() {
    if (this.channel) {
      this.channel.unbind();
    }
  }

  componentDidUpdate() {
    const {
      handleSuccessAsyncJob,
      handleFailedAsyncJob,
      eventAsyncJob,
    } = this.props;
    if (this.channel) {
      this.channel.unbind();
    }
    if (eventAsyncJob.channelName !== null) {
      this.channel.bind(eventAsyncJob.channelName, data => {
        if (data.job_id && data.success) {
          handleSuccessAsyncJob(data.resource_id);
        } else if (data.job_id && !data.success) {
          handleFailedAsyncJob(data.error);
        }
      });
    }
  }

  render() {
    const {
      modifiers,
      showLoadingSpinnerPage,
      openRightColumn,
      showSetAllItemConfirmationModal,
      showDeleteModifierModal,
      deletedModifier,
    } = this.props;
    const modifierName = deletedModifier ? deletedModifier.name : '';
    return (
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={modifiers.length === 0}
              title="No Data To Display"
              description=""
              linkLabel="Create Modifiers"
              linkUrl="https://mokaposhelp.zendesk.com/hc/id/articles/900000454546-Cara-Membuat-Modifiers"
            />
            {!showLoadingSpinnerPage && modifiers.length > 0 && <List />}
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <Detail />
          </RightColumnWrapper>
        </ContentWrapper>
        <ApplySetItemModal
          onSubmit={this.onSubmitApplySetItem}
          onClickApplyAll={this.onClickApplyAll}
        />
        <ConfirmSetAllItemModal
          showSetAllItemConfirmationModal={showSetAllItemConfirmationModal}
          onClickCancel={this.onCancelSetAllitem}
          onClickConfirm={this.onConfirmSetAllItem}
        />
        <LibraryDeleteModal
          showDeleteModal={showDeleteModifierModal}
          onHide={this.onHideModalDelete}
          title="Modifier"
          name={modifierName}
          onDelete={this.onDelete}
        />
        <ConfirmActionModal />
      </PageWrapper>
    );
  }

  onSubmitApplySetItem = values => {
    const { confirmApplySetItem } = this.props;
    confirmApplySetItem(
      { business_level_item_ids: values.business_level_item_ids },
      values.id
    );
  };

  onClickApplyAll = id => {
    const { onClickApplyAllitem } = this.props;
    onClickApplyAllitem(id);
  };

  onCancelSetAllitem = () => {
    const {
      setModifierApplyAllItems,
      closeSetAllItemConfirmation,
    } = this.props;
    setModifierApplyAllItems(null);
    closeSetAllItemConfirmation();
  };

  onConfirmSetAllItem = () => {
    const { modifierIdSetAllItem, confirmApplySetItem } = this.props;
    confirmApplySetItem({ selectAllItems: true }, modifierIdSetAllItem);
  };

  onDelete = () => {
    const { deleteModifier, deletedModifier, modifiers } = this.props;
    deleteModifier(deletedModifier.id, modifiers);
  };

  onHideModalDelete = () => {
    const { setDeletedModifier, hideDeleteModifierModal } = this.props;
    setDeletedModifier(null);
    hideDeleteModifierModal();
  };

  routerWillLeave = location => {
    const { isDirtyModifier, askConfirmAction } = this.props;
    if (isDirtyModifier && !this.props.nextAction) {
      askConfirmAction(push(location));
      return false;
    }
  };
}

const mapDispatchToProps = {
  askConfirmAction,
  pageRequest,
  deleteModifier,
  confirmApplySetItem,
  onClickApplyAllitem,
  setModifierApplyAllItems,
  closeSetAllItemConfirmation,
  setDeletedModifier,
  hideDeleteModifierModal,
  handleSuccessAsyncJob,
  handleFailedAsyncJob,
};

function mapStateToProps(state) {
  const {
    deletedModifier,
    eventAsyncJob,
    modifierIdSetAllItem,
    modifiers,
    openRightColumn,
    showSetAllItemConfirmationModal,
    showDeleteModifierModal,
  } = state.businessLibrary.modifierHub;
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  const isDirtyModifier = isDirty('modifierHub')(state);
  return {
    deletedModifier,
    isDirtyModifier,
    eventAsyncJob,
    modifierIdSetAllItem,
    modifiers,
    openRightColumn,
    showDeleteModifierModal,
    showLoadingSpinnerPage,
    showSetAllItemConfirmationModal,
    nextAction: state.confirmAction.nextAction,
    businessId: state.moka.user.business.id,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Modifier);
